<template>
<div>
  <div id="selfservice-timerequest">
      <div class ="vx-row">
          <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
                  <vx-card title="Timekeeping Manager"  
                    title-color="#fff"
                    content-color="#fff"   
                    card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)">
                      <template slot="actions">
                          <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                      </template>
                    
                          <vs-button class="mt-2 mr-3 shadow-lg" :color="!isBreak && !isDisabled ? 'success' : isDisabled && !isBreak ? 'warning' : 'primary'" type="gradient" gradient-color-secondary="#78E395"  @click=" !isBreak && !isDisabled ? onClockIn() : onBreakOut() ">{{ !isBreak && !isDisabled ? 'Clock-In' : isDisabled && !isBreak ? 'Break-Out' : 'Resume'}}</vs-button>
                          <!-- <vs-button class="mt-2 mr-3 shadow-lg" icon-pack="feather" :icon="!isBreak && !isDisabled ? 'icon-clock' : isDisabled && !isBreak ? 'icon-coffee' : 'icon-arrow-down'" :color="!isBreak && !isDisabled ? 'success' : isDisabled && !isBreak ? 'warning' : 'primary'" type="gradient" gradient-color-secondary="#78E395"  @click=" !isBreak && !isDisabled ? onClockIn() : onBreakOut() ">{{ !isBreak && !isDisabled ? 'Clock-In' : isDisabled && !isBreak ? 'Break-Out' : 'Resume'}}</vs-button> -->
                          <vs-button class="mt-2 mr-3 shadow-lg" color="danger" type="gradient" gradientColorSecondary="#f77777" @click="onClockOut()" :disabled="!isDisabled">Clock-Out</vs-button>
                          
                        
                  </vx-card>
                  
          </div>
          <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base">
                    <vx-card title="Clock-In"
                    title-color="#fff"
                    content-color="#fff"
                    card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)">
                    
                        <template slot="actions">
                            <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-white"></feather-icon>
                        </template>
                        <h2 class="mb-5"><strong class="ql-font-serif ql-size-large" >{{ clockIn.In != null ? clockIn.In : '----/--/-- 00:00:00 AM' }}</strong></h2>
                        
                    </vx-card>
                    
            </div>
            <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base">
                    <vx-card title="Break Hours"
                    title-color="#fff"
                    content-color="#fff"
                    card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)">
                        <template slot="actions">
                            <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-white"></feather-icon>
                        </template>
                          <h2  class="mb-5"><strong class="ql-font-serif ql-size-large"  >{{formattedElapsedTime}}</strong></h2>

                    </vx-card>
                    
            </div>
            <div class="vx-col w-full md:w-1/4 sm:w-1/2 mb-base">
                    <vx-card title="Clock-Out"
                    title-color="#fff"
                    content-color="#fff"
                    card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)">
                        <template slot="actions">
                            <feather-icon icon="MoreVerticalIcon" svgClasses="w-6 h-6 text-white"></feather-icon>
                        </template>
                            <h2 class="mb-5" ><strong class="ql-font-serif ql-size-large" >{{ clockOut.Out != null ? clockOut.Out : '----/--/-- 00:00:00 AM'}}</strong></h2>
                    </vx-card>
                    
            </div>
      </div>
  </div>
  <div id="simple-calendar-app">
    <div class="vx-card no-scroll-content">
      <calendar-view
        ref="calendar"
        :displayPeriodUom="calendarView"
        :show-date="showDate"
        :events="simpleCalendarEvents"
        enableDragDrop
        :eventTop="windowWidth <= 400 ? '2rem' : '3rem'"
        eventBorderHeight="0px"
        eventContentHeight="1.65rem"
        class="theme-default"
        @click-date="openAddNewSegment"
        @click-event="openEditSegment"
        >

        <div slot="header" class="mb-4">

          <div class="vx-row no-gutter">

            <!-- Month Name -->
            <div class="vx-col w-1/3 items-center sm:flex hidden">
              <!-- Add new event button -->
              <vs-button icon-pack="feather" icon="icon-plus" @click="promptAddNewEvent(new Date())">Add</vs-button>
            </div>

            <!-- Current Month -->
            <div class="vx-col sm:w-1/3 w-full sm:my-0 my-3 flex sm:justify-end justify-center order-last">
              <div class="flex items-center">
                <feather-icon
                  :icon="$vs.rtl ? 'ChevronRightIcon' : 'ChevronLeftIcon'"
                  @click="updateMonth(-1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />

                <span class="mx-3 text-xl font-medium whitespace-no-wrap">{{ showDate | month }}</span>

                <feather-icon
                  :icon="$vs.rtl ? 'ChevronLeftIcon' : 'ChevronRightIcon'"
                  @click="updateMonth(1)"
                  svgClasses="w-5 h-5 m-1"
                  class="cursor-pointer bg-primary text-white rounded-full" />
              </div>
            </div>

            <div class="vx-col sm:w-1/3 w-full flex justify-center">
              <template v-for="(view, index) in calendarViewTypes">
                <vs-button
                  v-if="calendarView === view.val"
                  :key="String(view.val) + 'filled'"
                  type="filled"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
                <vs-button
                  v-else
                  :key="String(view.val) + 'border'"
                  type="border"
                  class="p-3 md:px-8 md:py-3"
                  :class="{'border-l-0 rounded-l-none': index, 'rounded-r-none': calendarViewTypes.length !== index+1}"
                  @click="calendarView = view.val"
                  >{{ view.label }}</vs-button>
              </template>

            </div>
          </div>

          <div class="vx-row sm:flex hidden mt-4">
            <div class="vx-col w-full flex">
              <!-- Labels -->
              <div class="flex flex-wrap sm:justify-start justify-center">
                  <div v-for="(label, index) in calendarLabels" :key="index" class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2" :class="'bg-' + label.color"></div>
                      <span>{{ label.text }}</span>
                  </div>
                  
                  <div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-success"></div>
                      <span>Clock-In</span>
                  </div>
                  <div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-danger"></div>
                      <span>Clock-Out</span>
                  </div>
                  <div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-warning"></div>
                      <span>Break-Out</span>
                  </div>
                  <div class="flex items-center mr-4 mb-2">
                      <div class="h-3 w-3 inline-block rounded-full mr-2 bg-primary"></div>
                      <span>Break-In</span>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </calendar-view>
    </div>

     <!-- ADD EVENT -->
    <!-- <vs-prompt
        class="email-compose"
        title="Add Segment"
        accept-text= "Submit"
        @accept="addNewSegment"
        :is-valid="validForm"
        :active.sync="activePromptAddSegment">
        <vx-card title="Enter the following information"> 
            <div class="my-4">
                <small class="date-label">Schedule Date</small><span style="color:red">*</span>
                <datepicker :language="$vs.rtl ? langHe : langEn" name="schedule-date" v-model="employeeTimesheet.scheduleDate" ></datepicker>
            </div>
            <div class="my-4">
                <small class="date-label">Shift</small><span style="color:red">*</span>
                <v-select name="shift-type" v-model="shiftType" label="shiftTypeName" :options="getShiftTypes"/> 
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">Schedule In</span>
                    <flat-pickr  name="start-date" class="w-full" v-model="employeeTimesheet.schedIn" :config="configFromdateTimePicker" :disabled="true" />
                </div>
                <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                    <span  class="text-sm">Schedule Out</span>
                    <flat-pickr  name="end-date" class="w-full" v-model="employeeTimesheet.schedOut" :config="configTodateTimePicker" :disabled="true" />
                </div>
            </div>
            <div class="my-4">
                <small class="date-label">Segment</small><span style="color:red">*</span>
                <v-select name="segment-type" v-model="segmentType" label="segmentTypeName" :options="getSegmentTypes"/>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                <small class="date-label">Date & Time</small><span style="color:red">*</span>
                <flat-pickr :language="$vs.rtl ? langHe : langEn" name="date-time" v-model="employeeTimesheet.dateTime" :config="configdateTimePicker" ></flat-pickr>
              </div>
            </div>
            <div class="my-4">
                <small class="date-label">Reason</small><span style="color:red">*</span>
                <vs-input name="reason" v-validate="'required'" class="w-full" placeholder="Reason" v-model="employeeTimesheet.reason"></vs-input>
            </div>
            <div class="my-4">
               
            </div>
        </vx-card>
    </vs-prompt>  -->
    
  </div>
</div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { CalendarView, CalendarViewHeader } from 'vue-simple-calendar'
import moduleCalendar from '@/store/calendar/moduleCalendar.js'
import moduleTimekeeping from '@/store/timekeeping/moduleTimekeeping.js'
require('vue-simple-calendar/static/css/default.css')
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import moment from 'moment'
export default {
  data(){
    return {
      employeeTimeSheet: {
        employeeFiledTimeSheetId: null,
        employeeScheduleId: null,
        segmentTypeId: null,
        badgeTimeIn: '----/--/-- 00:00:00 AM',
        badgeTimeOut: '----/--/-- 00:00:00 AM',
        reason: '',
        isManualAdded: false,
        addedOn: null,
        ipAddress: '',
        latitude: 0.0,
        longitude: 0.0,
        tzOffset: '',
        tzName: '',
        tzDST: true,
        deviceId: '',
        deviceName: '',
        deviceOS: '',
        remarks: '',
        fileId: '',
        subscriptionId: '',
        isDraft: false,
        isSubmitted: true,
        submittedOn: new Date(),
        isCancelled: false,
        cancelledOn: null,
        isRetracted: false,
        retractedOn: null,
        approversTKs: [],
      },
      
      langHe: he,
      langEn: en,
      showDate: new Date(),
      calendarView: 'month',
      currentMonth: new Date().getMonth(),
      calendarViewTypes: [
          {
          label: 'Month',
          val: 'month'
          },
          {
          label: 'Week',
          val: 'week'
          },
          {
          label: 'Year',
          val: 'year'
          }
      ],
      clockIn: {
        In: '--/--/---- 00:00:00 AM',
        isDisabled: false,
        isBreak: false,
      }, 
      clockOut: {
        Out: '--/--/---- 00:00:00 AM',
        isDisabled: false,
        isBreak: false,
      },
      breakIn: null,
      breakOut: null,
      isDisabled: false,
      isBreak: false,
      myInterval: undefined,
      breakTime: 0,
      isBreakTime: false,
      title: '',
      activePromptAddSegment: false,
      activePromptEditSegment: false
    }
  },
  created () {
      // this.$router.push('/pages/maintenance')
      this.$store.registerModule('calendar', moduleCalendar)
      this.getAllSegmentsByMonth(this.currentMonth)
      this.$store.dispatch('lookup/getAllShiftType')
      this.$store.dispatch('lookup/getAllSegmentType')
      const data = {
        dateToday: moment(this.curDate).format('YYYY-MM-DD'),
        userId: this.$store.state.AppActiveUser.uid
      }
      this.$store.dispatch('hrms/getEmployeeScheduleByDateToday', data)
        .then((res) => {
          this.employeeTimeSheet.employeeScheduleId = localStorage.getItem('scheduleId') != undefined || localStorage.getItem('scheduleId') != null ? localStorage.getItem('scheduleId') : res.data.data.employeeScheduleId


          this.clockIn.In = localStorage.getItem('clockIn') != undefined || localStorage.getItem('clockIn') != null ? localStorage.getItem('clockIn') : this.getLatestSegments(2, this.employeeTimeSheet.employeeScheduleId)  //'--/--/---- 00:00:00 AM'
          this.clockOut.Out = localStorage.getItem('clockOut') != null ? localStorage.getItem('clockOut') :  this.getLatestSegments(3, this.employeeTimeSheet.employeeScheduleId)
          
          this.isDisabled =  JSON.parse(localStorage.getItem('isDisabled')) != null ? JSON.parse(localStorage.getItem('isDisabled')) : this.isDisabled
          this.isBreak = JSON.parse(localStorage.getItem('isBreak')) != null ? JSON.parse(localStorage.getItem('isBreak')) : this.isBreak
          this.isBreakTime =  JSON.parse(localStorage.getItem('isBreakTime'))
          this.breakTime =  JSON.parse(localStorage.getItem('breakTime'))
          if(this.isBreakTime && !this.isDisabled && this.isBreak){
            this.myInterval = setInterval(() => {
              this.breakTime += 1000
            }, 1000);
          }
        //   console.log(JSON.stringify(res.data.data))
        //   this.employeeTimeSheet.employeeScheduleId = res.data.data.employeeScheduleId
        //   console.log(this.employeeTimeSheet.employeeScheduleId)
        })
      
      // this.getDefaultApprover()
      this.getCurrentLocation()
      this.getUserIPAddress()
      
      
  },
  computed: {
      simpleCalendarEvents() {
          return this.$store.state.timekeeping.calendarEvents
      },
      getApprovers() {
            let approver = []
            this.$store.state.timekeeping.approvers.forEach(a => {
                approver.push(a.approver)
            })
           
           
            return approver
      },
      approverName: {
            get() { let approversName = [] 
                    let approvers = this.employeeLeaves.approversTKs
                    approvers.forEach(a => {
                        approversName.push(this.$store.getters['timekeeping/approverName'](a).approver)
                    })
                return  approversName },
            set(obj) { 
                let approver = []
                this.employeeTimeSheet.approversTKs =[] 
                        obj.forEach(u => {
                            approver.push(u.userId)
                         })
                this.employeeTimeSheet.approversTKs = approver
            }
        },
      getAllSegmentsByMonth() {
          return (monthNumber) => {
              const payload = {
              sortBy: 'BadgeTimeIn',
              sortOrder: 'Desc',
              pageNumber: 1,
              pageSize: 100,
              month: monthNumber
            }
            //Get All Added Segment 
            this.$store.dispatch('timekeeping/getAllSegment', payload)
             .then(() => {
             })
          }
      },
      getShiftTypes() {
          return this.$store.state.lookup.getAllShiftType
      },
      getSegmentTypes() {
          return this.$store.state.lookup.getAllSegmentType
      },
      getCurrentSchedule() {
        return this.$store.state.hrms.scheduleToday
      //   var dateToday = moment(this.curDate).format('YYYY-MM-DD')
      //   console.log(this.$store.state.schedule.getAllCreateSchedule)
      //   console.log(this.$store.getters['schedule/getCreateScheduleIdByDateToday'](this.$store.state.AppActiveUser.uid, dateToday))
      //   return this.$store.getters['schedule/getEployeeScheduleIdByDateToday'](this.$store.state.AppActiveUser.uid, dateToday)
       
      },
      getLatestSegments() {
        return (segmentTypeId, scheduleId) => {
          const data = {
            scheduleId: scheduleId, //this.getCurrentSchedule.employeeScheduleId, 
            segmentTypeId: segmentTypeId
          }
          localStorage.setItem('scheduleId', data.scheduleId)
          this.employeeTimeSheet.employeeScheduleId = data.scheduleId
          console.log('DATA')
          console.log(data)
          this.$store.dispatch('timekeeping/getLatestSegments', data)
             .then((response) => {
               const d = response.data.data
               console.log(d)
               switch(segmentTypeId)
               {
                 case 2:
                    localStorage.removeItem('clockIn')
                    localStorage.removeItem('clockOut')
                    // localStorage.removeItem('scheduleId')
                    localStorage.removeItem('isDisabled')
                    localStorage.removeItem('isBreak')
                    localStorage.removeItem('breakTime')
                    localStorage.setItem('clockIn', moment(d.badgeTimeIn).local().format('YYYY-MM-DD hh:mm:ss A'))
                    this.clockIn.In = localStorage.getItem('clockIn') 
                    this.isDisabled = true;
                    this.isBreak = false; 
                    localStorage.setItem('isDisabled', JSON.stringify(this.isDisabled))
                    localStorage.setItem('isBreak', JSON.stringify(this.isBreak))
                    
                    return localStorage.getItem('clockIn') 
                   break;
      
               }
      //         //   localStorage.setItem('clockIn', data.segmentTypeId == 2 ? localStorage.getItem('clockIn') != null ? 1 : data.badgeTimeIn != null ? moment(data.badgeTimeIn).local().format('YYYY-MM-DD hh:mm:ss A') : this.employeeTimeSheet.badgeTimeIn )
      //         //  this.clockIn.In = localStorage.getItem('clockIn')
      //         //  this.clockIn.Out = data.segmentTypeId == 3 ? localStorage.getItem('clockOut') != undefined ? localStorage.getItem('clockOut') : data.badgeTimeIn != undefined ? moment(data.badgeTimeIn).local().format('YYYY-MM-DD hh:mm:ss A') : this.employeeTimeSheet.badgeTimeIn : null
      //         //  this.breakIn = data.segmentTypeId == 4 ? moment(data.badgeTimeIn).local().format('YYYY-MM-DD hh:mm:ss A') : 0
      //         //  this.breakOut = data.segmentTypeId == 5 ? moment(data.badgeTimeIn).local().format('YYYY-MM-DD hh:mm:ss A') : 0

               })
            .catch(() => {
              console.log('CATCH')
              return '----/--/-- 00:00:00 AM'
            })
        }
          
      },
      shiftTypeName: {
         get() { return this.$store.getters['lookup/leaveTypeLookup'](this.employeeLeaves.leaveTypeId) },
            set(obj) { this.employeeLeaves.leaveTypeId = obj.leaveTypeId}
        
      },
      calendarLabels () {
          // return this.$store.state.calendar.eventLabels
          let sortedRecipes = this.$store.state.calendar.eventLabels;
		
          sortedRecipes = sortedRecipes.sort((a,b) => {
            let fa = a.createdOn, fb = b.createdOn;
            if (fa < fb) {
              return -1
            }
            if (fa > fb) {
              return 1
            }
            return 0
          })
        },
      windowWidth () {
          return this.$store.state.windowWidth
      },
      validForm () {
      },
      formattedElapsedTime() {
        const date = new Date(null);
        date.setSeconds(this.breakTime / 1000);
        const utc = date.toUTCString();
        return utc.substr(utc.indexOf(":") - 2, 8);
      },
    
  },
  methods: {
    onClockIn(){
      if( this.getCurrentSchedule.employeeScheduleId == null)
      {
        this.$alert('You have no schedule for today.', 'Clock-In failed', 'error' )
        return
      }
      this.employeeTimeSheet.segmentTypeId = 2
      this.employeeTimeSheet.employeeScheduleId =  this.getCurrentSchedule.employeeScheduleId
      localStorage.removeItem('clockIn')
      localStorage.removeItem('clockOut')
      localStorage.removeItem('scheduleId')
      localStorage.removeItem('isDisabled')
      localStorage.removeItem('isBreak')
      localStorage.removeItem('breakTime')
      localStorage.setItem('scheduleId', this.employeeTimeSheet.employeeScheduleId)
      
      this.clockIn.In = new Date().toLocaleString(); 
      this.clockOut.Out =  '--/--/---- 00:00:00 AM'
      this.employeeTimeSheet.badgeTimeIn = moment().format('MM/DD/YYYY hh:mm:ss A')
      this.employeeTimeSheet.badgeTimeOut =  moment().format('MM/DD/YYYY hh:mm:ss A')
      
      localStorage.setItem('clockIn', this.employeeTimeSheet.badgeTimeIn )
      localStorage.setItem('isDisabled', JSON.stringify(true))
      localStorage.setItem('isBreak', JSON.stringify(false))
      this.isDisabled = true;
      this.isBreak = false;  
      this.breakTime = 0;
     
      this.$store.dispatch('timekeeping/addSegment', this.employeeTimeSheet).catch(err => { console.error(err) }) 
      
    },
    onBreakIn(){
    },
    onClockOut(){
      this.employeeTimeSheet.segmentTypeId = 3
      this.clockOut.Out = new Date().toLocaleString(); 
      this.employeeTimeSheet.badgeTimeIn =  moment().format('MM/DD/YYYY hh:mm:ss A')
      this.employeeTimeSheet.badgeTimeOut =  moment().format('MM/DD/YYYY hh:mm:ss A')
      localStorage.removeItem('clockOut')
      localStorage.setItem('clockOut', this.employeeTimeSheet.badgeTimeOut)
      localStorage.setItem('isDisabled', JSON.stringify(false))
      localStorage.setItem('isBreak', JSON.stringify(false))
      this.isDisabled = false;
      this.isBreak = false; 
      
      this.clockOut.isDisabled = false;
      this.clockOut.isBreak =  false;
      this.$store.dispatch('timekeeping/addSegment', this.employeeTimeSheet).catch(err => { console.error(err) }) 
      
      
    },
    onBreakOut(){
      if(this.isDisabled && !this.isBreak)
      {
        this.employeeTimeSheet.segmentTypeId = 4
        this.isBreakTime = true
        this.clockOut.isDisabled = true
        // this.employeeTimeSheet.breakOut = new Date().toLocaleString()
        this.employeeTimeSheet.badgeTimeIn =   moment().format('MM/DD/YYYY hh:mm:ss A')
        this.employeeTimeSheet.badgeTimeOut =  moment().format('MM/DD/YYYY hh:mm:ss A')
     
 
        localStorage.setItem('breakOut', new Date().toLocaleString())
        this.myInterval = setInterval(() => {
          this.breakTime += 1000
          localStorage.setItem('breakTime', JSON.stringify(this.breakTime))
        }, 1000);
        
        localStorage.setItem('isBreakTime', JSON.stringify(true))
        
        this.$store.dispatch('timekeeping/addSegment', this.employeeTimeSheet).catch(err => { console.error(err) }) 
     
        
      }
      else //RESUME
      {
        this.employeeTimeSheet.segmentTypeId = 5
        this.employeeTimeSheet.badgeTimeIn =  moment().format('MM/DD/YYYY hh:mm:ss A')
        this.employeeTimeSheet.badgeTimeOut =  moment().format('MM/DD/YYYY hh:mm:ss A')
        this.isBreakTime = false
        // this.breakIn = new Date().toLocaleString();
        clearInterval(this.myInterval);
        this.$store.dispatch('timekeeping/addSegment', this.employeeTimeSheet).catch(err => { console.error(err) }) 
     
      }
      this.isDisabled = !this.isDisabled; 
      this.isBreak = !this.isBreak;
      localStorage.setItem('isDisabled', JSON.stringify(this.isDisabled))
      localStorage.setItem('isBreak', JSON.stringify(this.isBreak))
    },
                                                                                                                                                              
    openAddNewSegment(date) {
      this.employeeTimeSheet.startDate = date                      
      this.employeeTimeSheet.endDate = date                                                      
      activePromptAddSegment = true
    },                                                                                                             
    addNewSegment() {
    },
    openEditSegment(event) {
    },
    updateMonth (val) {
      this.showDate = this.$refs.calendar.getIncrementedPeriod(val)
      //console.log( this.showDate.getMonth() + 1)
      
      this.getAllSegmentsByMonth(this.showDate.getMonth() + 1)
      
    },
    addSegmentToCalendar (title) {
      const obj = { title: title, startDate: this.clockIn.In , endDate: this.clockOut.Out, label: title}
      obj.classes = `event-${  this.labelColor(this.labelLocal)}`
      this.$store.dispatch('calendar/addEvent', obj)
    },
    getDefaultApprover() {
        var approver = this.getApprovers
        this.approverName = approver
    },
    getCurrentLocation() {
        //console.log('dumaan dito sa location')
        if(navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            p => {
            this.employeeTimeSheet.latitude = p.coords.latitude
            this.employeeTimeSheet.longitude = p.coords.longitude
          },
            error => {
              console.log(error.message)
            })
        } else {
          //console.log('Your browser oes not support geolocation API')
        }
      },
    getUserIPAddress() {
        //console.log('dumaan dito sa IP')
        fetch('https://api.ipify.org?format=json')
        .then(x => x.json())
        .then(({ ip }) => {
            this.employeeTimeSheet.ipAddress = ip
            //console.log(ip)
        });
      },
  },
  components: {
      'v-select': vSelect,
        CalendarView,
        CalendarViewHeader,
        Datepicker,
        VuePerfectScrollbar,
        flatPickr,
    },
  
}
</script>

<style lang="scss">
// @import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>